$(document).ready(function () {
  $(".header-btn-wrapper").hide();
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 500) {
      $(".landing-page-header").addClass("darkHeader");
      $(".header-btn-wrapper").show();
    } else {
      $(".landing-page-header").removeClass("darkHeader");
      $(".header-btn-wrapper").hide();
    }
  });

  jQuery(".accordion1 dt").click(function () {
    jQuery(this)
      .find("i")
      .toggleClass("fa-angle-down fa-angle-up")
      .closest("dt")
      .next()
      .slideToggle()
      .siblings(".accordion_content1")
      .slideUp();

    // Ensure other accordion items close and their icons update accordingly
    jQuery(".accordion1 dt")
      .not(this)
      .find("i")
      .removeClass("fa-angle-up")
      .addClass("fa-angle-down");
  });
  jQuery(".accordion_content1").hide();

  jQuery(".accordion2 dt").click(function () {
    jQuery(this)
      .find("i")
      .toggleClass("fa-angle-down fa-angle-up")
      .closest("dt")
      .next()
      .slideToggle()
      .siblings(".accordion_content2")
      .slideUp();

    // Ensure other accordion items close and their icons update accordingly
    jQuery(".accordion2 dt")
      .not(this)
      .find("i")
      .removeClass("fa-angle-up")
      .addClass("fa-angle-down");
  });

  jQuery(".accordion_content2").hide();
  // Shows first "dt"
  // $("dd").hide().first().show();

  $(".reviews-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0680/7574/9672/files/prev.png?v=1718969063'></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0680/7574/9672/files/next.png?v=1718969062'></button>",
    centerPadding: "20px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  const setColor = (ele) => {
    if (ele.data("color")) {
      ele.closest(".splid-slider-section").css("background", ele.data("color"));
    }
  };

  $(".splide-slider")
    .on("init", (slick) => {
      setColor($(slick.target).find(".slick-active"));
    })
    .slick({
      fade: true,
      cssEase: "linear",
    })
    .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
      setColor(slick.$slider.find(`[data-slick-index=${nextSlide}]`));
    });

  $(".slick-prev").html(
    "<svg xmlns='http://www.w3.org/2000/svg' width='56' height='56' fill='none' stroke='#2D231A' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' viewBox='0 0 24 24'><circle cx='12' cy='12' r='10'></circle><path d='m12 8-4 4 4 4'></path><path d='M16 12H8'></path></svg>"
  );
  $(".slick-next").html(
    "<svg xmlns='http://www.w3.org/2000/svg' width='56' height='56' fill='none' stroke='#2D231A' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' viewBox='0 0 24 24'><circle cx='12' cy='12' r='10'></circle><path d='m12 16 4-4-4-4'></path><path d='M8 12h8'></path></svg>"
  );

  var width = $(window).width();
  if (width <= 768) {
    $(".review-block-grid")
      .slick({
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      })
      .on("setPosition", function (event, slick) {
        slick.$slides.css("height", slick.$slideTrack.height() + "px");
      });
  }

  $(".swiper-carousel-slider").slick({
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><div class='slick-slider-block'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 1L1 9L9 17' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'></path></svg></div></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><div class='slick-slider-block'><svg width='10' height='18' viewBox='0 0 10 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L9 9L1 17' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'></path></svg></div></button>",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 426,
        settings: {
          centerMode: true,
          centerPadding: "55px",
          slidesToShow: 1,
        },
      },
    ]
  });
  
});

var logo_slider = new Swiper(".log-swiper-slide", {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-next-arrow',
    prevEl: '.swiper-previous-arrow',
  },
  breakpoints: {
    990: {
      slidesPerView: 4,
      spaceBetween: 28,
    },
  }
});

var testimonial = new Swiper(".testimonial-slider-block", {
  slidesPerView: 1,
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-next-arrow',
    prevEl: '.swiper-previous-arrow',
  },
  breakpoints: {
    990: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
  }
});

var auther_slide = new Swiper(".slider-content-wrapper", {
  slidesPerView: 1.04,
  spaceBetween: 20,
  navigation: {
    nextEl: '.auther-next-arrow',
    prevEl: '.auther-previous-arrow',
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
  }
});

// var testimonial = new Swiper(".video-sec-slider", {
//   slidesPerView: 1,
//   spaceBetween: 15,
//   /*navigation: {
//     nextEl: '.swiper-next-arrow',
//     prevEl: '.swiper-previous-arrow',
//   },*/
//   breakpoints: {
//     990: {
//       slidesPerView: 4,
//       spaceBetween: 20,
//     },
//   }
// });

$(window).on("resize", function () {
  var width = $(window).width();
  if (width <= 768) {
    $(".review-block-grid")
      .slick({
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        rows: 0,
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      })
      .on("setPosition", function (event, slick) {
        console.log(slick);
        slick.$slides.css("height", slick.$slideTrack.height() + "px");
      });
  } else {
    setTimeout(function () {
      $(".review-block-grid").slick("unslick");
    }, 500);
  }
});
